import { useCallback } from 'react';
import { useNotifications } from './useNotifications';
import { captureError } from '@shared/lib/sentry';

export interface ErrorHandlerOptions {
  showNotification?: boolean;
  logToConsole?: boolean;
  rethrow?: boolean;
  sendToSentry?: boolean;
}

export const useErrorHandler = () => {
  const { showError } = useNotifications();

  const handleError = useCallback((
    error: Error | string | unknown,
    options: ErrorHandlerOptions = {}
  ) => {
    const {
      showNotification = true,
      logToConsole = true,
      rethrow = false,
      sendToSentry = true
    } = options;

    // Convertir el error a string
    let errorMessage: string;
    let errorTitle: string = 'Error';

    if (error instanceof Error) {
      errorMessage = error.message;
      errorTitle = error.name || 'Error';
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else {
      errorMessage = 'Error desconocido';
    }

  
    if (logToConsole) {
      // console.error('Error interceptado:', error);
    }

    if (sendToSentry && error instanceof Error) {
      captureError(error, {
        source: { value: 'useErrorHandler' },
        errorMessage: { value: errorMessage },
        errorTitle: { value: errorTitle },
        showNotification: { value: showNotification },
        logToConsole: { value: logToConsole },
      });
    }

    if (showNotification) {
      if (errorMessage.toLowerCase().includes('network') || 
          errorMessage.toLowerCase().includes('connection') ||
          errorMessage.toLowerCase().includes('fetch')) {
        showError('Error de conexión. Verifica tu conexión a internet e intenta de nuevo.', 'Error de red');
      } else if (errorMessage.toLowerCase().includes('permission') ||
                 errorMessage.toLowerCase().includes('unauthorized') ||
                 errorMessage.toLowerCase().includes('forbidden')) {
        showError('No tienes permisos para realizar esta acción.', 'Permiso denegado');
      } else {
        showError(errorMessage, errorTitle);
      }
    }


    if (rethrow) {
      throw error;
    }
  }, [showError]);

  const wrapAsyncFunction = useCallback(<T extends unknown[], R>(
    asyncFn: (...args: T) => Promise<R>,
    options: ErrorHandlerOptions = {}
  ) => {
    return async (...args: T): Promise<R | undefined> => {
      try {
        return await asyncFn(...args);
      } catch (error) {
        handleError(error, options);
        return undefined;
      }
    };
  }, [handleError]);

  return {
    handleError,
    wrapAsyncFunction,
  };
}; 